import React, { useEffect,useContext } from "react";
import { FormattedMessage } from "react-intl";
import useLocalStorage from "react-use-localstorage";
import { useQuery } from "react-query";
import axios from "axios";
import { useParams } from "react-router-dom";
import UserContext from "../../contexts/user";
import {SchedulePresentationEndpointResponseObject} from "../../types/presentation";
import QuizAnswerPodium from "../speaker-mode/quiz-answer-podium";
import ScreenAnswerPodium from "./screen-answer-podium";

const PodiumContainer: React.FC<{
  locale: string;
  setLocale: any;
  screen:boolean,

}> = ({ locale, setLocale ,screen}) => {

  const {
    event_slug,
    presentation_id,
    module = "video",
    question_id=""
  } = useParams<{
    event_slug: string;
    presentation_id: string;
    module?: string;
    question_id:string
  }>();
  const userContext = useContext(UserContext);
  const [eventPassword] = useLocalStorage(event_slug, "");
  const { setUser, setListUser,listUser } = userContext;



  useEffect(  () => {
    // check user is logged if not then fetch token for unique url
    const userList = JSON.parse(listUser);
    const getToken = async () => {
      console.log("GET_TOKEN user getTokens",userList.user)
      try{
      const response = await axios.post(
        `${process.env.REACT_APP_API_ENDPOINT}/api/get-token`,
        {
          params: { _id: presentation_id },
        }
      );

      var {token} = response.data
      setListUser(JSON.stringify({ token }));
       console.log("GET_TOKEN",token)
      }catch(e){

      }
    };

     console.log("GET_TOKEN CALL user",userList.user,(userList.user === null || userList.user === undefined))
    if(userList.user === null || userList.user === undefined){
       console.log("GET_TOKEN user inside",userList.user)
      //getToken();
    }
  });

  // get event data from back end
  const { data, isLoading, isError } = useQuery(
    ["presentation", presentation_id],
    async () => {
      const response =
        await axios.get<SchedulePresentationEndpointResponseObject>(
          `${process.env.REACT_APP_API_ENDPOINT}/api/public/schedule/${event_slug}/${presentation_id}`,
          {
            params: { password: eventPassword },
          }
        );
      return response.data;
    }
  );

  // if (isLoading) return <PreLoader />
  if (isError || !data) return <div></div>;

  const {
    data: { event, presentation },
  } = data;

   console.log("MODULE >>>",module);
if(screen){
  return (
      <ScreenAnswerPodium  event={event} locale={locale} setLocale={setLocale} presentation={presentation} questionId={question_id} />
  );
}

  return (
      <QuizAnswerPodium  event={event} locale={locale} setLocale={setLocale} presentation={presentation} questionId={question_id} />
  );
};

export default PodiumContainer;
